











































import Vue from 'vue';
import moment from 'moment';
import { required, maxLength } from 'vuelidate/lib/validators';
import {
  emailAddress,
  exactLength,
  lengthRange,
} from '@/validations';
import { ValidateEmail } from '@/components/validate-email-component';
import {
  FormValidation,
  CloseStepperWrapper,
  LoadingMessage,
} from '@/mixins';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';
import { RegistrationEmailFormModel, StepperSteps } from '@/@types/member';

interface Data {
  validateEmailIsLoading: boolean;
}

export default ExtendMixins(
  FormValidation,
  CloseStepperWrapper,
  LoadingMessage,
).extend({
  name: 'RegisterStep3Email',
  props: {
    formModel: {
      type: Object as () => RegistrationEmailFormModel,
      required: true,
    },
    step: {
      type: Object as () => StepperSteps,
      required: true,
    },
    brand: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      validateEmailIsLoading: false,
    };
  },
  validations: {
    formModel: {
      emailAddress: {
        emailAddress,
        required,
        maxLength: maxLength(120),
      },
    },
  },
  computed: {
    emailAddressErrors(): string[] {
      const formField = 'formModel.emailAddress';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-3-email-error-required',
            'global_form-error_email_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-3-email-error-invalid',
            'global_form-error_default_invalid-format',
          ],
          'emailAddress',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'register-step-3-email-error-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    brandPhone(): string {
      return this.$options.filters.t(`register-page-help-phone-${this.brand}`) ;
    },
  },
  mounted() {
    EventBus.$on('closeValidateEmailModal', this.closeModal);
    EventBus.$on('updateAndValidateEmail', (val) => {
      this.formModel.emailAddress = val;
      this.validateEmail();
    });
  },
  destroyed() {
    EventBus.$off('closeValidateEmailModal');
    EventBus.$off('updateAndValidateEmail');
  },
  components: {
    ValidateEmail,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
  methods: {
    submit(email): void {
      this.$emit('submitRegistrationEmail', email);
    },
    closeModal(): void {
      // @ts-ignore
      this.validateEmailModal = false;
    },
    validateEmail(): void {
      this.validateEmailIsLoading = true;
      this.step.isSubmitting = true;
      this.step.isSubmitting = true;
    },
    emailCancel(): void {
      this.step.isSubmitting = false;
      this.validateEmailIsLoading = false;
    },
    refreshAction(): void {
      this.step.isError = false;
    },
    doneAction(): void {
      this.$router.push('login');
    },
  },
});
